// extracted by mini-css-extract-plugin
export default {"badgesMainContainer":"Badges_badgesMainContainer__kHmVH","options":"Badges_options__2FJbj"};